import { createApp, defineAsyncComponent } from 'vue';
// import { createPinia } from 'pinia'

import SiteHeader from './components/SiteHeader.vue';
import SearchModalButton from './components/SearchModalButton.vue';
import DatePickerNoWeekends from './components/DatePickerNoWeekends.vue';

const app = createApp({});
// const pinia = createPinia();

// app.use(pinia);

app.config.compilerOptions.nativeTemplate = false;
app.config.compilerOptions.whitespace = 'preserve';

// Define asynchronous components
const asyncComponents = {
    AccordionItem: defineAsyncComponent(() => import(/* webpackChunkName: 'AccordionItem' */ './components/AccordionItem.vue')),
    ProgressBar: defineAsyncComponent(() => import(/* webpackChunkName: 'ProgressBar' */ './components/ProgressBar.vue')),
    DynamicModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'DynamicModalButton' */ './components/DynamicModalButton.vue')),
    TruncatedText: defineAsyncComponent(() => import(/* webpackChunkName: 'TruncatedText' */ './components/TruncatedText.vue')),
    ModalButton: defineAsyncComponent(() => import(/* webpackChunkName: 'ModalButton' */ './components/ModalButton.vue')),
    TabsWrapper: defineAsyncComponent(() => import(/* webpackChunkName: 'TabsWrapper' */ './components/TabsWrapper.vue')),
    Tab: defineAsyncComponent(() => import(/* webpackChunkName: 'Tab' */ './components/Tab.vue')),
    ImageComparisonSlider: defineAsyncComponent(() => import(/* webpackChunkName: 'ImageComparisonSlider' */ './components/ImageComparisonSlider.vue')),
    NumberCounter: defineAsyncComponent(() => import(/* webpackChunkName: 'NumberCounter' */ './components/NumberCounter.vue')),
    CardCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'CardCarousel' */ './components/CardCarousel.vue')),
    OverviewList: defineAsyncComponent(() => import(/* webpackChunkName: 'OverviewList' */ './components/OverviewList.vue')),
    LogoCarousel: defineAsyncComponent(() => import(/* webpackChunkName: 'LogoCarousel' */ './components/LogoCarousel.vue')),
    BaseSwiper: defineAsyncComponent(() => import(/* webpackChunkName: 'BaseSwiper' */ './components/BaseSwiper.vue')),
    AccordionListWrapper: defineAsyncComponent(() => import(/* webpackChunkName: 'AccordionListWrapper' */ './components/AccordionListWrapper.vue')),
    BlackbaudEvent: defineAsyncComponent(() => import(/* webpackChunkName: 'BlackbaudEvent' */ './components/BlackbaudEvent.vue')),
    EventOccurrencePicker: defineAsyncComponent(() => import(/* webpackChunkName: 'EventOccurrencePicker' */ './components/EventOccurrencePicker.vue')),
    AccessPlanItCoursesTable: defineAsyncComponent(() => import(/* webpackChunkName: 'AccessPlanItCoursesTable' */ './components/AccessPlanItCoursesTable.vue')),
    EventsOverviewCalendar: defineAsyncComponent(() => import(/* webpackChunkName: 'EventsOverviewCalendar' */ './components/EventsOverviewCalendar.vue')),
    ShopMap: defineAsyncComponent(() => import(/* webpackChunkName: 'ShopMap' */ './components/ShopMap.vue')),
    AddressFinder: defineAsyncComponent(() => import(/* webpackChunkName: 'AddressFinder' */ './components/AddressFinder.vue')),
    DonationBlock: defineAsyncComponent(() => import(/* webpackChunkName: 'DonationBlock' */ './components/DonationBlock.vue')),
    DonationSchedule: defineAsyncComponent(() => import(/* webpackChunkName: 'DonationSchedule' */ './components/DonationSchedule.vue')),
    TeamMemberCard: defineAsyncComponent(() => import(/* webpackChunkName: 'TeamMemberCard' */ './components/TeamMemberCard.vue')),
    DonationAmounts: defineAsyncComponent(() => import(/* webpackChunkName: 'DonationAmounts' */ './components/DonationAmounts.vue')),
    DatePickerNoWeekends: defineAsyncComponent(() => import(/* webpackChunkName: 'CustomDatePicker' */ './components/DatePickerNoWeekends.vue')),
};

// Register components asynchronously
for (const [componentName, asyncComponent] of Object.entries(asyncComponents)) {
    app.component(componentName, asyncComponent);
}

app.component('SiteHeader', SiteHeader);
app.component('SearchModalButton', SearchModalButton);

app.mount('#app');